import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import HeadingLines from "../assets/images/heading-lines.svg";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { Navigation, Thumbs } from "swiper/modules";
import SwiperCore from "swiper";

// import Testimonial1 from "../assets/images/testimonial-image.jpg";
// import testimonialUser1 from "../assets/images/testimonial-user-1.png";
// import testimonialUser2 from "../assets/images/testimonial-user-2.png";
// import testimonialUser3 from "../assets/images/testimonial-user-3.png";
// import testimonialUser4 from "../assets/images/testimonial-user-4.png";

import WatchVideo from "../assets/images/play-circle.svg";

import { useDispatch, useSelector } from "react-redux";
import { getTestimonials } from "../features/visitor/visitorActions";

// Initialize Swiper core
SwiperCore.use([Navigation, Thumbs]);

function HomeStories() {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const navigationPrevRef = React.useRef(null);
  const navigationNextRef = React.useRef(null);

  const dispatch = useDispatch();
  const { testimonialResponse } = useSelector((state) => state.visitor);

  useEffect(() => {
    dispatch(getTestimonials({ page: 1, limit: 10 }));
  }, [dispatch]);

  return (
    <>
      <section className="home-stories">
        <Container>
          <div className="common-header">
            <img src={HeadingLines} alt="" />
            <h2>Stories of Belonging</h2>
          </div>
          <div className="testimonials-slider">
            <Swiper
              slidesPerView={1}
              navigation={{
                prevEl: navigationPrevRef.current,
                nextEl: navigationNextRef.current,
              }}
              onBeforeInit={(swiper) => {
                swiper.params.navigation.prevEl = navigationPrevRef.current;
                swiper.params.navigation.nextEl = navigationNextRef.current;
              }}
              thumbs={{
                swiper:
                  thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null,
              }}
              loop={true}
              className="main-swiper"
            >
              {testimonialResponse !== null && (
                <>
                  {testimonialResponse?.data?.map((row, index) => (
                    <SwiperSlide key={"slide" + index}>
                      <img
                        className="testimonials-box-img"
                        src={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${row.banner_image}`}
                        alt=""
                      />
                      <div className="testimonials-box">
                        <div
                          className=""
                          dangerouslySetInnerHTML={{ __html: row?.description }}
                        ></div>
                        <Link
                          to={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${row.customer_video}`}
                          title="Watch Video"
                          className="custom-bttn green-btn"
                          target="_blank"
                        >
                          <img
                            className="location-img"
                            src={WatchVideo}
                            alt=""
                          />{" "}
                          Watch Video
                        </Link>
                      </div>
                    </SwiperSlide>
                  ))}
                </>
              )}
              <div className="swiper-button-nav">
                <div
                  ref={navigationPrevRef}
                  className="swiper-button-prev"
                ></div>
                <div
                  ref={navigationNextRef}
                  className="swiper-button-next"
                ></div>
              </div>
            </Swiper>
            {/* Thumbnail Slider */}
            <Swiper
              onSwiper={setThumbsSwiper}
              spaceBetween={30}
              slidesPerView={4}
              freeMode={true}
              watchSlidesProgress={true}
              loop={true}
              className="thumbs-swiper"
              breakpoints={{
                320: {
                  slidesPerView: 3,
                  spaceBetween: 10,
                },
                480: {
                  slidesPerView: 3,
                  spaceBetween: 20,
                },
                1024: {
                  slidesPerView: 4,
                  spaceBetween: 30,
                },
              }}
            >
              {testimonialResponse !== null && (
                <>
                  {testimonialResponse?.data?.map((row, index) => (
                    <SwiperSlide key={"thumb" + index}>
                      <img
                        src={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${row.customer_image}`}
                        alt={"Thumbnail " + index}
                      />
                    </SwiperSlide>
                  ))}
                </>
              )}
            </Swiper>
          </div>
        </Container>
      </section>
    </>
  );
}
export default HomeStories;
